import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Legend = styled.div`
	display: flex;
	flex-direction: ${({ placeItems }) => (placeItems === 'horizontal' ? 'row' : 'column')};
	flex-wrap: nowrap;
	justify-content: ${({ placeItems }) => (placeItems === 'horizontal' ? 'flex-end' : 'unset')};
	gap: 2rem;
	width: ${({ legendPlacement, minWidth }) => (legendPlacement === 'right' ? minWidth : '70%')};
	min-width: ${(props) => props.minWidth};

	max-height: 17rem;
	overflow: auto;
	padding: 0 2rem;
	margin: 1rem 2rem;

	@media ${Breakpoints.tablet} {
		width: ${({ legendPlacement, minWidth }) =>
			legendPlacement === 'right' ? `calc(100% - ${minWidth} - 5rem)` : '100%'};
	}

	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const LegendItem = styled.div`
	${({ placeItems }) =>
		placeItems === 'horizontal'
			? `
				width: unset;
				display: flex;
				align-items: center;
			`
			: `
				display: grid;
				grid-template-columns: 65% 35%;
				width: 100%;
				justify-content: space-between;
			`}

	cursor: pointer;
	padding: var(--padding-1) 0;
`;

export const LegendEntryTitle = styled.div`
	display: flex;
	gap: 0.5rem;
	align-items: center;
`;

export const LegendLine = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 2rem;
	width: 100%;
	justify-content: space-between;
	padding: var(--padding-1) 0;
`;
